<script setup>
import { computed, onMounted, watch } from "vue";
import { useBookingStore } from "@stores/BookingStore";

const props = defineProps({});
const bookingStore = useBookingStore();

const destinationName = computed(() => {
  return (
    bookingStore.currentDestinationInfo?.name ||
    bookingStore.query.destination?.name ||
    "Selected Destination"
  );
});

const allTravellersVaccinations = computed(() => {
  return bookingStore.currentDestinationInfo?.all_travellers_vaccinations || [];
});

const someTravellersVaccinations = computed(() => {
  return (
    bookingStore.currentDestinationInfo?.some_travellers_vaccinations || []
  );
});

const isLoading = computed(
  () =>
    bookingStore.currentDestinationInfo === null &&
    bookingStore.query.destination?.id
);

onMounted(() => {
  if (bookingStore.query.destination?.id) {
    bookingStore.fetchDestinationInfo(bookingStore.query.destination.id);
  }
});

watch(
  () => bookingStore.query.destination?.id,
  (newId, oldId) => {
    if (newId && newId !== oldId) {
      bookingStore.fetchDestinationInfo(newId);
    } else if (!newId) {
      bookingStore.currentDestinationInfo = null; // Clear if destination is removed
    }
  }
);
</script>

<template>
  <div v-if="bookingStore.query.destination?.id">
    <h2 class="mb-20 font-medium text-20 text-grey">
      Vaccinations for {{ destinationName }}
    </h2>

    <div v-if="isLoading" class="py-20 text-center">
      Loading destination info...
    </div>
    <div v-else class="gap-6 grid lg:grid-cols-12">
      <Box
        v-if="allTravellersVaccinations.length > 0"
        class="lg:col-span-8 bg-white">
        <h3 class="mb-20 font-medium text-grey">
          All travellers should consider
        </h3>
        <ul class="grid sm:grid-cols-2 md:grid-cols-3 list-syringe">
          <li
            v-for="vaccination in allTravellersVaccinations"
            :key="vaccination.id"
            class="mb-10">
            <a
              :href="vaccination.url"
              v-html="vaccination.name"
              class="text-blue"
              target="_blank">
            </a>
          </li>
        </ul>
        <!-- <template #footer>
          Arrange a consultation
          <strong class="text-grey-dark">6 weeks </strong> before your trip for
          necessary vaccinations and treatment.
        </template> -->
      </Box>
      <div
        v-else-if="
          !isLoading &&
          allTravellersVaccinations.length === 0 &&
          someTravellersVaccinations.length === 0
        "
        class="lg:col-span-12 bg-white p-20 rounded-lg">
        <p>
          No specific vaccination recommendations found for all travellers to
          {{ destinationName }}. It's always best to consult with a travel
          health professional.
        </p>
      </div>

      <Box
        v-if="someTravellersVaccinations.length > 0"
        class="lg:col-span-4 bg-white">
        <h3 class="mb-20 font-medium text-grey">
          Some travellers should consider
        </h3>
        <ul class="list-syringe">
          <li
            v-for="vaccination in someTravellersVaccinations"
            :key="vaccination.id"
            class="mb-10">
            <a :href="vaccination.url" class="text-blue" target="_blank">
              {{ vaccination.name }}
            </a>
          </li>
        </ul>
      </Box>
    </div>
  </div>
</template>
